module.exports = __webpack_public_path__ + "fonts/nuxt-fontagon-icon.1a8d4fd.woff";